export const navLinks = [
    
  {
    label: 'Projects',
    pathname: '/',
    hash: '#project-1',
  },
  {
    label: 'Articles',
    pathname: '/articles',
  },
  {
    label: 'About',
    pathname: '/',
    hash: '#about',
  },
  {
    label: 'Contact',
    pathname: '/contact',
  },
];

export const socialLinks = [
  {
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/in/akib-sheikh-bb5a17190/',
    icon: 'linkedin',
  },
  {
    label: 'Dribbble',
    url: 'https://www.instagram.com/akibsheikh1/?igshid=1n35acwkvzx00',
    icon: 'dribbble',
  },
  {
    label: 'Github',
    url: 'https://github.com/Akibsheikh48',
    icon: 'github',
  },
];
